module.exports = __webpack_public_path__ + "img/trial-icon.d7e4068d.svg";